import {
  type LicenseSeatPerson,
  seatPersonNameOf,
} from "@/v2-backoffice-client/license/seats/license.seats.utils"

export type LicenseSeatPersonLabelProps = {
  person: LicenseSeatPerson
  /** Appended to the e-mail line, e.g. when and by whom a seat was granted. */
  detail?: string | null
}

// The one two-line rendering of a person on a seat list — the seat panel's
// rows and the grant dialog's holders to pick — so a person reads the same
// wherever seats are decided.
function LicenseSeatPersonLabel(props: LicenseSeatPersonLabelProps) {
  const { person, detail } = props

  return (
    <div className="min-w-0">
      <div className="truncate text-sm font-medium">
        {seatPersonNameOf(person)}
      </div>
      <div className="truncate text-xs text-muted-foreground">
        {person.Email}
        {detail ? ` · ${detail}` : ""}
      </div>
    </div>
  )
}

export default LicenseSeatPersonLabel
